import { Check, Maximize2 } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

const Shot = ({ f }) => (
  <Dialog>
    <DialogTrigger asChild>
      <button className="group relative block w-full overflow-hidden rounded-xl border border-line bg-inset shadow-[0_30px_80px_rgba(0,0,0,0.45)] text-left" data-testid={`feature-shot-${f.id}`}>
        <span className="flex items-center gap-1.5 border-b border-line px-3 py-2">
          {["#f87171", "#fbbf24", "#34d399"].map((c) => <span key={c} className="h-2 w-2 rounded-full opacity-70" style={{ background: c }} />)}
        </span>
        <img src={`/features/${f.shot}.jpg`} alt={f.title} loading="lazy" className="block w-full transition-transform duration-500 group-hover:scale-[1.015]" />
        <span className="absolute bottom-3 right-3 rounded-full bg-black/70 p-2 text-[#fde68a] opacity-0 transition-opacity group-hover:opacity-100"><Maximize2 className="w-4 h-4" /></span>
      </button>
    </DialogTrigger>
    <DialogContent className="max-w-[min(1600px,95vw)] border-line bg-canvas p-2" data-testid={`feature-shot-dialog-${f.id}`}>
      <DialogTitle className="sr-only">{f.title}</DialogTitle>
      <img src={`/features/${f.shot}.jpg`} alt={f.title} className="w-full rounded-lg" />
    </DialogContent>
  </Dialog>
);

export const FeatureRow = ({ f, flip, accent = "text-amber-500/80" }) => (
  <article className="grid lg:grid-cols-12 gap-8 lg:gap-14 items-center" data-testid={`feature-${f.id}`}>
    <div className={`lg:col-span-8 ${flip ? "lg:order-2" : ""}`}><Shot f={f} /></div>
    <div className={`lg:col-span-4 space-y-4 ${flip ? "lg:order-1" : ""}`}>
      <p className={`font-code text-[11px] uppercase tracking-[0.3em] ${accent}`}>{f.kicker}</p>
      <h3 className="font-display text-3xl text-amber-50 leading-tight">{f.title}</h3>
      <p className="text-sm leading-relaxed text-slate-400">{f.text}</p>
      <ul className="space-y-1.5 pt-1">
        {f.points.map((p) => <li key={p} className="flex gap-2 text-sm text-slate-300"><Check className="mt-0.5 h-4 w-4 shrink-0 text-amber-400" />{p}</li>)}
      </ul>
    </div>
  </article>
);
